import Fetcher from "../../../Common/Fetch";

export function getFailedTradeReason(failedTrade: Number) {
    return Fetcher(`/TradeLotApi/GetFailedTradeReason?reason=${failedTrade}` , {
        method: 'GET', headers: { 'Content-Type': 'application/json' }
    })
        .then(res => res.json());
}

export function finishTrade(lotId: Number) {
    return Fetcher(`/TradeLotActionsApi/FinishTrade?lotId=${lotId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        }
    })
}